import { GET_ACCESS_CONTROLS } from './types.js';

export const doGetAccessControls = ({ entityIds, onFinish }) => ({
    type: GET_ACCESS_CONTROLS,
    api: { version: 2, name: 'GetAccessControls' },
    params: { assetIds: entityIds },
    onFinish
});
